import type { ChecklistSummary } from '../../features/onboarding/onboardingChecklist';
import type { Tone } from '../../ui/v2';

export interface StoreOnboardingStatus {
  store_id: number;
  store_name: string;
  status: 'complete' | 'incomplete';
  completed: boolean;
  issues: string[];
  /** Platform admins only: the store's checklist stage and progress. */
  checklist?: ChecklistSummary;
}

/**
 * Accepts a list, a paginated `results` list, or a single status object.
 * A null body throws, which the loader reports as a failed request.
 */
export const onboardingStatusesFrom = (
  data: unknown,
): StoreOnboardingStatus[] => {
  if (Array.isArray(data)) return data;
  const { results } = data as { results?: unknown };
  if (Array.isArray(results)) return results;
  return [data as StoreOnboardingStatus];
};

export const onboardingStatusLabel = (status: StoreOnboardingStatus) =>
  status.completed ? 'Complete' : 'Incomplete';

export const onboardingStatusTone = (status: StoreOnboardingStatus): Tone =>
  status.completed ? 'success' : 'warning';

export const onboardingIssueCount = (status: StoreOnboardingStatus) =>
  status.issues?.length || 0;
